var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPythonGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 125,
    rx: 15,
    fill: "#97D3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2268 36.2804V35.7804H62.7268H38.6366V26.7566C38.6366 19.4503 44.7583 13.5 52.3443 13.5H73.6557C81.2417 13.5 87.3632 19.4502 87.3632 26.7566V50.0371C87.3632 56.1745 82.2202 61.1771 75.8414 61.1771H49.6121C41.5045 61.1771 34.9044 67.5452 34.9044 75.4339V86.5739H27.2076C19.6218 86.5739 13.5 80.6238 13.5 73.3175V52.6825C13.5 45.3762 19.6218 39.4259 27.2076 39.4259H62.7268H63.2268V38.9259V36.2804ZM49.0657 30.4312C52.0426 30.4312 54.4836 28.0904 54.4836 25.1693C54.4836 22.2482 52.0426 19.9074 49.0657 19.9074C46.0885 19.9074 43.6475 22.2482 43.6475 25.1693C43.6475 28.0904 46.0885 30.4312 49.0657 30.4312Z",
    fill: "url(#paint0_linear_1_196)",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7724 89.7197V90.2197H63.2724H87.3628V99.2436C87.3628 106.55 81.2409 112.5 73.6549 112.5H52.3435C44.7579 112.5 38.636 106.55 38.636 99.2436V75.9629C38.636 69.8255 43.779 64.8229 50.1578 64.8229H76.3874C84.4947 64.8229 91.0949 58.4552 91.0949 50.5661V39.426H98.7917C106.378 39.426 112.499 45.3762 112.499 52.6825V73.3175C112.499 80.6238 106.378 86.5743 98.7917 86.5743H63.2724H62.7724V87.0743V89.7197ZM76.9339 95.5689C73.9567 95.5689 71.5157 97.9095 71.5157 100.831C71.5157 103.752 73.9567 106.092 76.9339 106.092C79.9108 106.092 82.3517 103.752 82.3517 100.831C82.3517 97.9095 79.9108 95.5689 76.9339 95.5689Z",
    fill: "url(#paint1_linear_1_196)",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_196",
    x1: 50.4318,
    y1: 13,
    x2: 50.4318,
    y2: 87.0739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1565A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_196",
    x1: 75.5678,
    y1: 38.926,
    x2: 75.5678,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonGroup);
export default __webpack_public_path__ + "static/media/PythonGroup.8326ec8e555cba6c0638775bf69643db.svg";
export { ForwardRef as ReactComponent };